<template>
	<span :class="classes" :style="iconStyle" v-on="$listeners"><slot></slot></span>
<!--	{{ iconName }}</span>-->
</template>

<script>
export default {
	props: {
		"color": {
			type: String,
			default: ""
		},
		"size": {
			type: [Number, String],
			default: ""
		},
		"small": {
			type: Boolean,
			default: false
		},
		"large": {
			type: Boolean,
			default: false
		},
		"xLarge": {
			type: Boolean,
			default: false
		},
		"disabled": {
			type: Boolean,
			default: false
		},
		"left": {
			type: Boolean,
			default: false
		},
		"right": {
			type: Boolean,
			default: false
		},
		"type": {
			type: String,
			default: "icons"
		},
		"inherit": {
			type: Boolean,
			default: false
		}
	},
	computed: {
		"iconName" () {
			if (this.$slots.default && this.$slots.default[0]) {
				return (this.$slots.default[0].text || "").trim()
			}
			return ""
		},
		"classes" () {
			var ret = {}
			if (this.type === "icons") {
				ret["material-icons"] = true
			} else {
				ret["material-symbols"] = true
			}
			ret["ks-icon"] = true
			ret["ks-icon-inherit"] = this.inherit
			ret["ks-icon-disabled"] = this.disabled
			ret["ks-icon-left"] = this.left
			ret["ks-icon-right"] = this.right
			if (this.color) {
				ret["ks-icon-" + this.color] = true
			} else {
				ret['ks-icon-inherit'] = true;
			}
			return ret
		},
		"iconStyle" () {
			var style = {}
			if (this.size) {
				if (this.size == "xs") {
					style.fontSize = "16px"
				} else if (this.size == "s") {
					style.fontSize = "18px"
				} else if (this.size == "m") {
					style.fontSize = "20px"
				} else if (this.size == "l") {
					style.fontSize = "24px"
				} else if (this.size == "xl") {
					style.fontSize = "28px"
				}
/*				var s = typeof this.size === "number" ? this.size + "px" : this.size
				style.fontSize = s*/
			} else if (this.small) {
				style.fontSize = "16px"
			} else if (this.large) {
				style.fontSize = "36px"
			} else if (this.xLarge) {
				style.fontSize = "48px"
			}
			if (this.color && !this.colorIsClass(this.color)) {
				style.color = this.color
			}
			return style
		}
	},
	methods: {
		colorIsClass (color) {
			var named = ["accent", "primary", "success", "danger", "warning", "info", "white", "light-grey"]
			return named.indexOf(color) !== -1
		}
	}
}
</script>

<style>
.ks-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	color: var(--ks-font-color);
	vertical-align: middle;
	user-select: none;
	transition: color 0.15s ease;
}

.ks-icon-disabled {
	opacity: 0.4;
	pointer-events: none;
}

.ks-icon-left {
	margin-right: 6px;
}

.ks-icon-right {
	margin-left: 6px;
}

/* Named colors */
.ks-icon-accent {
	color: var(--ks-col-accent);
}
.ks-icon-primary {
	color: var(--ks-col-primary);
}
.ks-icon-success {
	color: var(--ks-col-success);
}
.ks-icon-danger {
	color: var(--ks-col-danger);
}
.ks-icon-warning {
	color: var(--ks-col-warning);
}
.ks-icon-info {
	color: var(--ks-col-info);
}
.ks-icon-white {
	color: var(--ks-white);
}
.ks-icon-light-grey {
	color: var(--ks-light-grey);
}
.ks-icon-inherit {
	color: inherit !important;
}
</style>
